/**
 * The dog's moving parts, in the artwork's coordinate space.
 *
 * Each part has a `clip` - the region the moving piece draws - and a `hole`,
 * which is cut out of the otherwise-static body. The hole is strictly inside the
 * clip on every edge, so however the part rotates it always overlaps the hole it
 * has to cover. Sharing an edge between the two is what produced thin
 * transparent slivers at the joints in earlier attempts.
 *
 * Each pivot sits at the top of its hole, so the seam barely moves while the far
 * end of the limb swings. Pivots are in viewBox units, which is why the groups
 * that use them also set `transform-box: view-box`.
 *
 * These were measured by rendering the artwork under a coordinate grid; redo
 * that if you ever replace the paths in dogArt.ts.
 */
export const PARTS = {
  frontLegs: {
    clip: 'M42 184 H134 V314 H42 Z',
    hole: 'M58 200 H118 V314 H58 Z',
    pivot: '88px 203px',
  },
  hindLegs: {
    clip: 'M186 184 H328 V314 H186 Z',
    hole: 'M200 200 H315 V314 H200 Z',
    pivot: '258px 203px',
  },
  tail: {
    clip: 'M244 104 L258 152 L292 176 L330 184 L351 180 L351 78 L300 84 L262 94 Z',
    hole: 'M260 112 L272 146 L300 166 L330 174 L351 170 L351 86 L300 92 L268 102 Z',
    pivot: '266px 126px',
  },
} as const

/** Everything, minus the three holes. `evenodd` is what makes them holes. */
export const BODY_CLIP = `M0 0 H351 V309 H0 Z ${PARTS.frontLegs.hole} ${PARTS.hindLegs.hole} ${PARTS.tail.hole}`
